/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { Page, Content, InContentMessage } from '@insticator/insticator-ui'; // iui-material
// pages
import AnalyticsOverview from 'pages/dashboard/analytics/overview/overview_container';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/home/home_styles';



/* ========== ~~~~~~~~~~ HOME ~~~~~~~~~~ ========== */
const HomePage = (props) =>
    <Page name={`home`} klass={props.classes.home}>
        <InContentMessage/>
        <Content>
            <AnalyticsOverview />
        </Content>
    </Page>



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(HomePage);
